/*
  Renders any existing legacy page inside the V2 shell without duplicating logic.
  The scoping `.zj-v2` isolates our new tokens from legacy CSS.
  Legacy Tailwind classes still apply globally.
*/
export default function LegacyEmbed({ children }) {
  return (
    <div className="v2-page" data-testid="v2-legacy-embed" style={{ padding: 0 }}>
      <div style={{ background: "var(--v2-bg)", borderRadius: 0 }}>
        {children}
      </div>
    </div>
  );
}
